import { connect } from 'react-redux';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { actions as personalisationActions } from 'src/redux/personalisation/slice';
import { selectProduct } from 'src/redux/product/selectors';
import type { AppThunkDispatch } from 'src/redux/store';
import { isOutOfStock } from 'src/utils/inventoryStatus';
import type { ProductOptionsDispatchProps, ProductOptionsStateProps } from './ProductOptions';
import { ProductOptions } from './ProductOptions';

const mapDispatchToProps = (dispatch: AppThunkDispatch): ProductOptionsDispatchProps => {
  return {
    onChangeQuantity: ({ quantity, valid }) => {
      dispatch(personalisationActions.changeQuantity({ isValid: valid, quantity }));
    },
  };
};

const mapStateToProps = (state: ReduxApplicationState): ProductOptionsStateProps => {
  const product = selectProduct(state);

  return {
    inStock: !isOutOfStock(product.inventoryStatus),
    quantity: state.personalisation.quantity,
    showPriceBreakdown: Boolean(product.options.length),
  };
};

export const ProductOptionsContainer = connect(mapStateToProps, mapDispatchToProps)(ProductOptions);
